import { makeStyles } from "@mui/styles";
import { COLORS } from "../../constant/colors";

const useStyles = makeStyles({
  accountContainer: {
    minHeight: "100vh",
    paddingTop: "140px",
    "@media (max-width: 991px)": {
      paddingTop: "130px",
    },
    "@media (max-width: 500px)": {
      paddingTop: "100px",
    },
  },
  accountHeader: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    padding: "50px 0 60px",
    color: COLORS.white,
    position: "relative",
    marginBottom: "20px",
    textAlign: "center",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "25px",
      backgroundImage: "url('/images/footer-wave.svg')",
      backgroundSize: "auto 100%",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "bottom center",
      transform: "rotate(180deg) translateY(-1px)",
      zIndex: 1,
    },
    "@media (max-width: 600px)": {
      padding: "30px 0 50px",
      "&::after": {
        height: "25px",
      },
    },
  },
  accountTitle: {
    fontSize: "2rem",
    fontWeight: "600",
    margin: "0",
    textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
    textAlign: "center",
    position: "relative",
    zIndex: 2,
    "@media (max-width: 768px)": {
      fontSize: "1.8rem",
    },
  },
  accountContent: {
    display: "flex",
    gap: "25px",
    padding: "20px 0",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "15px",
    },
  },
  sidebar: {
    width: "280px",
    backgroundColor: COLORS.white,
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    position: "sticky",
    top: "160px",
    height: "fit-content",
    "@media (max-width: 768px)": {
      width: "100%",
      position: "static",
      top: "auto",
    },
    "@media (max-width: 500px)": {
      top: "120px",
    },
  },
  sidebarHeader: {
    padding: "25px",
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    color: COLORS.white,
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  userAvatar: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    color: COLORS.white,
  },
  userDetails: {
    flex: 1,
  },
  userName: {
    fontSize: "18px",
    fontWeight: "600",
    margin: "0 0 5px 0",
    color: COLORS.white,
  },
  userEmail: {
    fontSize: "14px",
    opacity: 0.9,
    margin: 0,
    color: COLORS.white,
  },
  sidebarNav: {
    padding: "20px 0 0",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "15px 25px",
    color: COLORS.textPrimary,
    textDecoration: "none",
    transition: "all 0.3s ease",
    borderLeft: "3px solid transparent",
    "&:hover": {
      backgroundColor: "rgba(169, 37, 60, 0.05)",
      color: COLORS.primary,
      textDecoration: "none",
      borderLeftColor: COLORS.primary,
      "& i": {
        color: COLORS.primary,
      },
    },
  },
  navItemActive: {
    backgroundColor: "rgba(169, 37, 60, 0.1)",
    color: COLORS.primary,
    borderLeftColor: COLORS.primary,
    fontWeight: "600",
    "& i": {
      color: COLORS.primary,
    },
  },
  navIcon: {
    fontSize: "16px",
    marginRight: "12px",
    width: "20px",
    textAlign: "center",
    color: "inherit",
    display: "inline-block",
  },
  navLabel: {
    fontSize: "15px",
    fontWeight: "500",
    color: "inherit",
  },
  navDivider: {
    height: "1px",
    backgroundColor: "#e5e5e5",
    marginTop: "15px",
  },
  logoutButton: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    width: "100%",
    padding: "20px 25px",
    textAlign: "left",
    "&:hover": {
      backgroundColor: "rgba(220, 53, 69, 0.1)",
      color: "#dc3545",
      "& i": {
        color: "#dc3545",
      },
    },
  },
  mainContent: {
    flex: 1,
    backgroundColor: "transparent",
    borderRadius: "12px",
    overflow: "hidden",
    minHeight: "auto",
    padding: 0,
  },
});

export default useStyles;
